export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`relative overflow-hidden select-none ${className}`} aria-hidden="true">
      <div className="marquee-track animate-marquee whitespace-nowrap">
        {doubled.map((item, i) => (
          <span key={`${item}-${i}`} className="inline-flex items-center">
            <span className="font-display uppercase text-[9vw] md:text-[6vw] leading-none tracking-tight px-8">
              {item}
            </span>
            <span className="h-3 w-3 rounded-full bg-ptf-accent shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
